import { Link as RouterLink } from "react-router-dom";
import { Card, Link, Typography } from "@mui/material";

const SignUpSuccess: React.FC = () => {
  return (
    <Card
      elevation={8}
      sx={{ display: "grid", placeItems: "center", gap: 2, p: 4, borderRadius: "1rem", mb: 4 }}
    >
      <Typography variant="h1" fontSize="2rem" textAlign="center">
        Klart!
      </Typography>

      <Typography textAlign="center">
        Ditt konto har nu skapats och du är välkommen att logga in.
      </Typography>

      <Link component={RouterLink} to="/login" underline="hover" color="primary.dark">
        Logga in
      </Link>
    </Card>
  );
};

export default SignUpSuccess;
